module.exports = __webpack_public_path__ + "static/media/about_nature.7cde80dc.mp4";